import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './Navbar';
import Home from './Home.js';
import Create from './Create';
import Deposit from './Deposit';
import Withdraw from './Withdraw';
import Alldata from './Alldata';
import {HashRouter,Routes,Route} from 'react-router-dom';
import userContext from './Context.js';
import { useState } from 'react';

function App(){

  const[users,setUsers]=useState([{"name":"Janani","email":"janani@gmail.com","password":"123456","amount":100000}])
  const [amount, setAmount] = useState(0);
 

 
  return(<>
  <HashRouter>
    <userContext.Provider value={{users,setUsers,amount,setAmount}}>
    <Navbar></Navbar>
    <Routes>
      <Route path='/Home' element={<Home></Home>}></Route>
      <Route path='/Create' element={<Create></Create>}></Route>
      <Route path='/Deposit' element={<Deposit></Deposit>}></Route>
      <Route path='/Withdraw' element={<Withdraw></Withdraw>}></Route>
      <Route path='/Alldata' element={<Alldata></Alldata>}></Route>
    </Routes>
    </userContext.Provider>
  </HashRouter> 
  </>)
}

export default App;